import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import WhatsAppTermsContent from '../components/WhatsAppTermsContent.jsx';

function WhatsAppTerms() {
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        handleClose();
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [handleClose]);

  useEffect(() => {
    const { style } = document.body;
    const originalOverflow = style.overflow;
    style.overflow = 'hidden';

    return () => {
      style.overflow = originalOverflow;
    };
  }, []);

  return (
    <div className="whatsapp-terms-page" onClick={handleClose} role="presentation">
      <div className="whatsapp-terms-page__backdrop" />

      <div
        className="modal-content modal-content--terms whatsapp-terms-page__modal"
        role="dialog"
        aria-modal="true"
        aria-label="Termo de Ciência e Responsabilidade"
        onClick={(event) => event.stopPropagation()}
      >
        <WhatsAppTermsContent />

        <div className="whatsapp-terms-page__actions">
          <button type="button" className="modal-close-button" onClick={handleClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default WhatsAppTerms;
